import Vue from 'vue'
import qs from 'querystring'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import Vue2TouchEvents from 'vue2-touch-events'
import vkrouter from 'foundation/vkrouter.js'
import VueLazyload from 'vue-lazyload'

import logService from './util/logService'
import toast from './ui/toast/toast'
import messageBox from './ui/messageBox/messageBox.js'
import vklink from '@/ui/link'

import lodashGet from 'lodash.get'

import filters from './filters'

// 绑定过滤器
console.log('fitlers is', filters)
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
})

Vue.use(toast)
Vue.use(messageBox)
Vue.use(VueLazyload)

Vue.use(Vue2TouchEvents)
const { channel_id: channelId } = qs.parse(location.search.replace('?', ''))
Vue.use(logService, {
    channel_id: channelId
})

Vue.config.productionTip = false

Vue.config.errorHandler = (error, vm, info) => {
    const logService = vm.$logService
    let params = {
        info: info
    }
    const isAxiosError = lodashGet(error, 'isAxiosError', false)
    if (isAxiosError) {
        const { config, response } = error
        params = Object.assign({
            category: 'axiosError',
            url: config.url,
            status: response.status
        }, params)
    } else {
        params = Object.assign({
            category: 'common',
            message: error.message,
            stack: error.stack.substr(0, 1000)
        }, params)
    }
    logService.pageTrigger('web_exception', params)
    if (process.env.NODE_ENV !== 'production') {
        console.error('[vue]RenderError', error)
    } else {
        console.warn('[vue]RenderError', error)
    }
}

Vue.use(vkrouter)
Vue.component('vklink', vklink)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
